import { registerResponseInterceptor } from '../api';

registerResponseInterceptor((response) => {
  if (typeof window.onAPIResponse === 'function') {
    const titleWithEnv = window.document.title?.split(' - ')?.[0];
    const screenName = titleWithEnv?.slice(4, titleWithEnv?.length);

    const duration = Number(
      response?.headers?.['x-response-time']?.replace('ms', '')
    );
    if (duration) {
      window.onAPIResponse({
        url: response.config.url,
        screen: screenName,
        duration: duration,
      });
    }
  }

  return response;
}, 'GA');
